import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unipile-callback',
  template: '<div class="unipile-callback"><h1>Connection finished!</h1><p>Please wait while we close the popup…</p></div>',
  styles: [
    `
    .unipile-callback {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 16px;
      
      /* Account for standard window bar height (typically ~40px) */
      height: calc(800px - 40px);
      width: 1024px;
      background-color: #ffffff;

      h1 {
        color: #000000;
        font-size: 24px;
        font-weight: 600;
        text-align: center;
      }

      p {
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-clamp: 2;
      }
    }
    `
  ]
})
export class UnipileCallbackComponent implements OnInit {
  ngOnInit(): void {
    try {
      const params = new URLSearchParams(window.location.search);
      const success = params.get('success') === 'true';
      
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'UNIPILE_DONE', success },
          window.location.origin
        );
      }
    } catch (err) {
      // Suppress errors that may occur from browser extensions
      // trying to access window.opener after it's been closed
      console.warn('Error sending postMessage (likely from extension cleanup):', err);
    }
  }
}
